/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ForwardRefExoticComponent } from "react";
import { CodeBlock } from "./docs-code";

type Hook = (...args: any[]) => any;
type AnyComponent = FC<any> | ForwardRefExoticComponent<any> | Hook | string;

type ImportExampleProps = {
	component: AnyComponent | AnyComponent[];
	lab?: boolean;
};

function componentName(component: any) {
	return component.displayName || component.name || component;
}

export function ImportExample({ component, lab = false }: ImportExampleProps): JSX.Element {
	const names = (Array.isArray(component) ? component : [component]).map(componentName);
	const stmt = `import { ${names.join(", ")} } from "@siteimprove/fancyl${lab ? "a" : "i"}b";`;
	return (
		<div style={{ position: "relative", borderRadius: 3, overflow: "hidden", marginBottom: 32 }}>
			<button
				onClick={() => navigator.clipboard.writeText(stmt)}
				style={{ position: "absolute", right: 32, top: 15 }}
			>
				Copy
			</button>
			<CodeBlock language="tsx" style={{ paddingTop: 16, paddingBottom: 16, margin: 0 }}>
				{stmt}
			</CodeBlock>
		</div>
	);
}
